import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { CardInfoDetailV2Component } from '@commons/card-info-detail-v2/card-info-detail-v2.component';

@Component({
    selector: 'check-times',
    templateUrl: './check-times.component.html',
    styleUrls: ['./check-times.component.scss'],
    standalone: true,
    imports: [CardInfoDetailV2Component, NgIf],
})
export class CheckTimesComponent {
  @Input()
  staticInfo: any;

  constructor() {}
  @Input()
  mobile = false;
}
